import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import NumberFormat from 'react-number-format';
import { withStyles } from 'material-ui/styles/index';
import GridItem from '../../../common/components/Drawer/GridItem';
import DrawerDivider from '../../../common/components/Drawer/DrawerDivider';
import SectionTitle from '../../../common/components/Typography/SectionTitle';

const styles = () => ({
    root: {
        marginLeft: '24px',
    },
});

function ApplicantsIncome(props) {
    return (
        <div>
            <DrawerDivider />
            <div className={props.classes.root}>
                <SectionTitle>
                    Applicants income
                </SectionTitle>
                <Grid
                    className={props.classes.grid}
                    container
                    spacing={0}
                >
                    {props.applicantsIncome.map((applicantIncome, index) => (
                        <GridItem
                            key={applicantIncome}
                            caption={`Applicant ${index + 1} taxable income`}
                        >
                            <NumberFormat
                                value={applicantIncome.amount}
                                displayType="text"
                                thousandSeparator
                                prefix="&pound;"
                            />
                        </GridItem>
                    ))}
                </Grid>
            </div>
        </div>
    );
}

ApplicantsIncome.propTypes = {
    applicantsIncome: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ApplicantsIncome);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/components/ApplicantsIncome.js